export const BUTTON_FONT_SIZE = "14px";
export const BUTTON_ICON_SIZE = "24px";
export const NAV_BUTTON_FONT_SIZE = "12px";
export const NAV_BUTTON_ICON_SIZE = "16px";
export const BUTTON_ICON_MARGIN_RIGHT = "-6px"
